import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home__hero",
  ref: "hero"
}
const _hoisted_2 = { class: "home__title text-h0" }
const _hoisted_3 = { class: "home__title-wrapper" }
const _hoisted_4 = { class: "home__title-wrapper _row" }
const _hoisted_5 = { class: "home__title-wrapper _second" }
const _hoisted_6 = { class: "home__title-wrapper _row" }
const _hoisted_7 = { class: "home__star _mobile" }
const _hoisted_8 = { class: "home__star" }
const _hoisted_9 = {
  ref: "subtitleElement",
  class: "home__subtitle"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Read Tarot", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_touch_ripple = _resolveComponent("touch-ripple")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["home", { '_cover-header': _ctx.isCoverHeader }]),
    style: _normalizeStyle({ paddingTop: _ctx.paddingTop })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              ref: (el) => _ctx.setElementsRef(el)
            }, "Year of the Dragon", 512)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              ref: (el) => _ctx.setElementsRef(el, true)
            }, "Fortune", 512),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_inline_svg, {
                class: _normalizeClass(["svg-star", { 'active': _ctx.svgAnimation.star3 }]),
                src: require('@/assets/svg/star/5.svg'),
                name: "star-5"
              }, null, 8, ["class", "src"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_inline_svg, {
              class: _normalizeClass(["svg-star", { 'active': _ctx.svgAnimation.star2 }]),
              src: require('@/assets/svg/star/2.svg'),
              name: "star-2"
            }, null, 8, ["class", "src"])
          ]),
          _createElementVNode("span", {
            ref: (el) => _ctx.setElementsRef(el)
          }, "Cards", 512)
        ])
      ]),
      _createElementVNode("p", _hoisted_9, " The New Year is a unique season, brimming with magical vibes. Here, in the virtual oracle, you can catch a glimpse of what the future holds. Embrace the strength of the Dragon and receive a prediction blending ancient traditions with modern technologies. May its wisdom light up your journey! ", 512),
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.beforeLeave().then(() => {
            _ctx.store.setView('spread', 'home')
          }))),
        ref: "mainBtn",
        class: _normalizeClass(["home__btn btn-main _transparent", { '_disabled': _ctx.isBlockBtn }])
      }, [
        _createVNode(_component_touch_ripple, {
          color: "#859dff",
          opacity: 0.1,
          transition: "ease-out",
          duration: 300,
          "keep-last-ripple": false
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["opacity"])
      ], 2)
    ], 512)
  ], 6))
}